import { BoxLeadEntity } from "@modules/boxLead/entities/boxLeadEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export const useBoxLeads = (page?: number, size?: number, name?: string) => {
  const { boxLeadApi } = useServicesContext()

  const { data, isLoading, isFetching } = useSuspenseQuery({
    queryKey: ["boxLeads", page, size, name],
    queryFn: async () => {
      return boxLeadApi.getBoxLeads(page, size, name)
    },
  })

  return {
    data: {
      ...data,
      content: data.content.map((lead) => BoxLeadEntity.fromDto(lead)) || [],
    },
    isFetching,
    isLoading,
  }
}
